import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { MODE_ORDER_ID, MODE_ORDER_NUMBER } from '../constants'

const MODES = [MODE_ORDER_NUMBER, MODE_ORDER_ID]

// Both identifiers are numeric, so nothing can auto-detect which was typed; the
// operator says which one it is.
export default function OrderIdentifierInput({ mode, value, onModeChange, onValueChange, disabled }) {
  const { t } = useTranslation()
  const key = suffix => t(`natura_operations.picking.${suffix}`)

  return (
    <>
      <fieldset className="mb-4">
        <legend className="block text-sm font-medium text-gray-700 mb-2">{key('mode_label')}</legend>
        <div className="flex flex-wrap gap-4">
          {MODES.map(m => (
            <label key={m} className="inline-flex items-center gap-2 text-sm">
              <input
                type="radio"
                name="picking-resend-mode"
                value={m}
                checked={mode === m}
                disabled={disabled}
                onChange={() => onModeChange(m)}
                className="text-amber-500 focus:ring-amber-500"
              />
              {key(`mode_${m}`)}
            </label>
          ))}
        </div>
      </fieldset>

      <div className="mb-2">
        <label htmlFor="picking-identifier" className="block text-sm font-medium text-gray-700 mb-1">
          {key(`field_label_${mode}`)}
        </label>
        <input
          id="picking-identifier"
          type="text"
          inputMode="numeric"
          value={value}
          disabled={disabled}
          onChange={e => onValueChange(e.target.value)}
          className="w-full max-w-xs font-mono text-sm border border-gray-300 rounded p-2 disabled:bg-gray-100"
          placeholder={key(`field_placeholder_${mode}`)}
        />
        <p className="mt-1 text-xs text-gray-500">{key(`field_hint_${mode}`)}</p>
      </div>
    </>
  )
}

OrderIdentifierInput.propTypes = {
  mode: PropTypes.oneOf(MODES).isRequired,
  value: PropTypes.string.isRequired,
  onModeChange: PropTypes.func.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

OrderIdentifierInput.defaultProps = {
  disabled: false,
}
